import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Breadcrumbs, Button, MenuItem, MenuList, Popover, Stack } from '@ff-it/ui';
import { useRealUser, useSessionScope } from 'services';
import { Icon } from './Icon';
import { Impersonation } from './Impersontation';
import { EnterpriseLink } from 'components/EnterpriseLink';
import { GlobalSearch } from './GlobalSearch';
import { EnterpriseSwitcher } from './EnterpriseSwitcher';
import { UserAvatar } from './UserAvatar';
import { IndicatorBadge } from 'core/Indicators';

export function TopNav(): ReactElement {
  const user = useRealUser();
  const scope = useSessionScope();

  return (
    <nav className="navbar navbar-light bg-light border-bottom navbar-expand p-0" id="top-nav">
      <div className="mr-auto d-flex align-items-center">
        <EnterpriseSwitcher />
        <Breadcrumbs className="mb-0" />
      </div>
      <Stack direction="horizontal" mr="2" align="center">
        <GlobalSearch />
        <Impersonation />
        {scope.kind === 'AGENCY' ? (
          <IndicatorBadge counter="unseen_notifications" placement="bottom-end">
            <Button variant="ghost" size="xs" icon="inbox" asChild>
              <EnterpriseLink to="notifications" />
            </Button>
          </IndicatorBadge>
        ) : null}
        <Popover
          placement="bottom-end"
          content={
            <MenuList>
              <MenuItem label={user.email} prefix={<Icon icon="user" />} component={EnterpriseLink} to="/profile" />
              <MenuItem label="Sign out" prefix={<Icon icon="right-from-bracket" />} component={NavLink} to="/logout" />
            </MenuList>
          }
        >
          <Button variant="ghost" size="xxs">
            <UserAvatar user={user} size="xs" noTooltip />
          </Button>
        </Popover>
      </Stack>
    </nav>
  );
}
